// §5.4 — the policy the kernel holds before a skin has mounted one.
//
// `WindowManagerPolicy` is a *skin* contract (§6.1) and `kernel/**` may not import `skins/**`
// (§6.5), so the composition root starts with this and the host replaces it with the active
// skin's on mount and on every skin change. It snaps nothing and offers no zones: "no skin has
// told me what an edge means yet" is a true answer, and guessing one would make the house
// behaviour appear for a moment under every other skin.
import type { WindowManagerPolicy } from '@hangar/shared';

export const NULL_POLICY: WindowManagerPolicy = {
  onMaximizeButton: () => 'maximize',
  onEdgeDrag: () => null,
  snapZones: () => [],
  switcherModel: () => 'windows',
  minimizeTarget: () => 'barSlot',
  chromeSide: () => 'right',
  snapAssist: () => false,
};
